<template>
  <vx-card class="fill" title-color="primary">
    <b-container fluid>
      <form data-vv-scope="data-user">
        <h3>Solicitud de Materiales</h3>
        <div class="row mt-3">
          <div class="col-4">
            <label>Fecha de Solicitud:</label>
            <b-form-datepicker
              id="datepicker-request"
              locale="es"
              placeholder="Elige una fecha"
              size="md"
              v-model="userData.dateRequest"
              :min="minDate"
            ></b-form-datepicker>
          </div>
          <div class="col-4">
            <label>Fecha de Retiro:</label>
            <b-form-datepicker
              id="datepicker-request-end"
              locale="es"
              placeholder="Elige una fecha"
              size="md"
              v-model="userData.dateRequestEnd"
              :min="minDate"
            ></b-form-datepicker>
          </div>
        </div>
        <div class="row mt-3" id="user-list">
          <div class="col-4">
            <label>Nombre Solicitud:</label>
            <b-form-input
              placeholder="Ingresa Solicitud"
              size="md"
              v-model="userData.request"
              name="request"
              :state="errors.has('data-user.request') ? false : null"
              v-validate="'required'"
            />
            <b-form-invalid-feedback>
              {{ errors.first('data-user.request') }}
            </b-form-invalid-feedback>
          </div>
          <div class="col-8">
            <label>Descripción:</label>
            <b-form-input
              placeholder="Descripcion"
              size="md"
              v-model="userData.description"
              name="description"
              :state="errors.has('data-user.description') ? false : null"
              v-validate="'required'"
            />
            <b-form-invalid-feedback>
              {{ errors.first('data-user.description') }}
            </b-form-invalid-feedback>
          </div>
        </div>
        <div class="row mt-3">
          <div
            class="col-4 demo-inline-spacing"
            v-if="isLoadOptionList"
          >
            <b-spinner
              key="primary"
              variant="primary"
            />
          </div>
          <div
            class="col-4"
            v-if="!isLoadOptionList"
          >
            <label>Entidad:</label>
            <OptionList @select-item="getChildrenEntities"/>
          </div>
          <div class="col-8">
            <label>Entidad Hija:</label>
            <div
              class="children-entities"
            >
              <div class="row mt-3" v-if="isLoadOptionChildrenList">
                <b-spinner key="primary" class="ml-5 mt-3" variant="primary"/>
              </div>
              <b-form-checkbox-group
                v-model="selectedEntities"
                id="checkbox-group-children-entities"
                name="flavour-2"
                class="mt-3"
                :options="childrenEntities"
                value-field="entity"
                text-field="entity.name"
                v-if="!isLoadOptionChildrenList"
              >
              </b-form-checkbox-group>
            </div>
<!--            {{selectEntities}}-->
          </div>
        </div>
        <br>
        <br>
        <div class="row mt-3">
          <div class="col-8">
            <h3>Materiales</h3>
            <span class="font-medium-1 text-primary" v-if="!enableMaterialsTable">
              Debes seleccionar al menos una entidad hija para continuar
            </span>
          </div>
          <div class="col-4" v-if="enableMaterialsTable">
            <vs-dropdown class="dropdown-option-menu" vs-trigger-click>
              <vs-chip color="primary">
                <vs-avatar color="primary" icon="add"/>
                Agregar materiales
              </vs-chip>
              <vs-dropdown-menu class="scroll-options">
                <vs-dropdown-item
                  class="dropdown-option"
                  @click="openModalFromUnit"
                >
                  Desde Unidad
                </vs-dropdown-item>
                <vs-dropdown-item
                  class="dropdown-option"
                  @click="openModalFromCatalog"
                >
                  Desde Catálogo
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <b-list-group
              v-for="(entity) of selectedEntitiesList"
              :key="entity.id"
            >
              <b-list-group-item
                :v-b-toggle="'accordion-' + entity.id"
                button
                role="tab"
                :key="entity.id"
                @click="onActiveAccordion(entity.id)"
              >
                <div class="row">
                  <div class="col-11">
                    {{ entity.name }}
                  </div>
                  <div class="col-1">
                    <em v-if="isAccordionOpen && activeAccordionId === entity.id"
                        class="fa fa-chevron-down"
                    ></em>
                    <em v-else
                        class="fa fa-chevron-up"
                    ></em>
                  </div>
                </div>
              </b-list-group-item>
              <div class="row">
                <div class="ml-5 mr-5">
                  <b-collapse
                    :id="'accordion-' + entity.id"
                    accordion="my-accordion"
                    role="tabpanel"
                    block
                    :visible="isAccordionOpen && activeAccordionId === entity.id"
                  >
                    <b-table
                      fixed responsive
                      :fields="fieldMaterial"
                      :items="entity.materials"
                      sticky-header
                      :key="'table-' + entity.id"
                      :id="'table-' + entity.id"
                      primary-key="id"
                    >
                      <template #cell(SKU)="row">
                        {{ row.item.SKU }}
                      </template>
                      <template #cell(nombre)="row">
                        {{ row.item.nombre }}
                      </template>
                      <template #cell(categoria)="row">
                        {{ row.item.categoria[0].descripcion || '' }}
                      </template>
                      <template #cell(marca)="row">
                        {{ row.item.marca.descripcion }}
                      </template>
                      <template #cell(cantidad)="row">
                        {{ parseInt(row.item.cantidad) }}
                      </template>
                      <template #cell(cantidadSolicitar)="row">
                        <b-form-spinbutton
                          v-model="row.item.cantidadSolicitar"
                          min="0"
                          max="100"
                          size="sm"
                          @change="totalRequest(row, entity)"
                        />
                      </template>
                      <template #cell(precio)="row">
                        {{ parseInt(row.item.precio) | toCurrency }}
                      </template>
                      <template #cell(total)="row">
                        {{ parseInt(row.item.total) | toCurrency }}
                      </template>
                      <template #cell(totalSolicitar)="row">
                        {{ parseInt(row.item.totalSolicitar) | toCurrency }}
                      </template>
                    </b-table>
                  </b-collapse>
                </div>
              </div>
            </b-list-group>
          </div>
        </div>
        <div v-if="enableMaterialsTable">
          <div class="row mt-3">
            <div class="col-4">
              <b-button
                class="btn"
                size="md"
                @click="resetMaterials"
                :disabled="!enableFinishButton"
              >
                <feather-icon icon="RefreshCwIcon"/>
                Reiniciar materiales
              </b-button>
            </div>
            <div class="col-8">
              <b-button
                class="btn btn-primary pull-right ml-3"
                size="md"
                @click="saveChanges"
                :disabled="!enableFinishButton"
              >
                <feather-icon icon="SaveIcon"/>
                Guardar
              </b-button>
            </div>
          </div>
          <div class="row">
            <span
              class="font-medium text-primary mr-5 dropdown-option-menu"
              v-if="!enableFinishButton"
            >
              Debes añadir al menos un material a la solicitud
            </span>
          </div>
        </div>
      </form>
    </b-container>
    <PopUpAddFromUnity
      ref="fromUnityModal"
      @reload="addFromUnity"
    />
    <PopUpAddFromCatalog
      ref="fromCatalogModal"
      @reload="addFromCatalog"
    />
  </vx-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PopUpAddFromUnity from '@/febos/global/materialsRequests/vistas/modals/PopUpAddFromUnity';
import OptionList from '@/febos/global/materialsRequests/components/OptionList';
import { listV2Options } from '@/febos/servicios/api/opciones.api';
import PopUpAddFromCatalog from '@/febos/global/materialsRequests/vistas/modals/PopUpAddFromCatalog';
import OptionTreeMixins from '@/febos/global/empresas/componentes/options/OptionTreeMixin';
import MaterialTableFields from '@/febos/global/materialsRequests/mixins/MaterialTableFields';
// import router from '@/router';

export default {
  name: 'CreateMaterialsRequests',
  mounted() {
    this.loadOptionList();
  },
  data() {
    return {
      selectedEntities: [],
      userData: {
        name: '',
        request: '',
        description: '',
        dateRequest: this.$moment().format('YYYY-MM-DD'),
        dateRequestEnd: this.$moment().format('YYYY-MM-DD'),
        detail: []
      },
      minDate: this.$moment().format('YYYY-MM-DD'),
      isLoadOptionList: true,
      isLoadOptionChildrenList: false,
      childrenEntities: [],
      selectEntities: [],
      activeAccordionId: '',
      isAccordionOpen: false,
      fieldMaterial: MaterialTableFields.fieldMaterial
    };
  },
  components: {
    PopUpAddFromUnity,
    PopUpAddFromCatalog,
    OptionList
  },
  computed: {
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('Materials', [
      'entities',
      'loading'
    ]),
    enableMaterialsTable() {
      return this.selectedEntitiesList.length > 0;
    },
    enableFinishButton() {
      return this.selectedEntitiesList.length > 0;
    },
    selectedEntitiesList() {
      return Object.values(this.selectEntities).filter((item) => item.selected);
    },
    requestFinalPrice() {
      let finalPrice = 0;
      Object.values(this.selectEntities).filter((item) => item.selected).forEach((entity) => {
        entity.materials.forEach((materials) => {
          finalPrice += materials.totalSolicitar;
        });
      });
      return finalPrice;
    }
  },
  mixins: [OptionTreeMixins],
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('Materials', [
      'updateOptionTreeEntities',
      'setLoading',
      'addMaterialRequest'
    ]),
    onActiveAccordion(entity) {
      if (this.activeAccordionId !== entity) {
        this.isAccordionOpen = true;
        this.activeAccordionId = entity;
      } else {
        this.isAccordionOpen = !this.isAccordionOpen;
      }
    },
    async loadOptionList() {
      try {
        this.isLoadOptionList = true;
        const response = await listV2Options({
          grupoOpcion: 'io.solicitud.material.entidades',
          filtros: 'deshabilitado:0',
          relacionUsuario: this.currentUser.id
        });
        const options = this.optionToTree(response.data.opciones || [], 2);
        await this.updateOptionTreeEntities(options);
      } finally {
        this.isLoadOptionList = false;
      }
    },
    async loadOptionChildrenList(optionId) {
      try {
        this.setLoading({ loading: true });
        this.isLoadOptionChildrenList = true;
        this.selectEntities = [];
        const response = await listV2Options({
          grupoOpcion: 'io.solicitud.material.entidades',
          filtros: 'deshabilitado:0',
          relacionUsuario: this.currentUser.id
        });
        const options = this.optionChildrenToList(optionId, response.data.opciones || []);
        const lastLevelNode = Math.max(...options.map((option) => option.levelNode));
        this.childrenEntities = options
          .filter((option) => option.levelNode === lastLevelNode)
          .map((entity) => ({
            entity: {
              id: entity.optionId,
              name: entity.name
            }
          }));
        this.selectEntities = this.childrenEntities.reduce((acumulador, entity) => ({
          ...acumulador,
          [entity.entity.id]: {
            ...entity.entity,
            materials: []
          }
        }), {});
        this.selectedEntities = this.childrenEntities.map((item) => item.entity);
      } finally {
        this.isLoadOptionChildrenList = false;
        this.setLoading({ loading: false });
      }
    },
    addFromCatalog(catalogMaterials) {
      this.selectEntities = Object.values(this.selectEntities).reduce((acumulador, entity) => ({
        ...acumulador,
        [entity.id]: {
          ...entity,
          materials: [
            ...entity.materials,
            ...catalogMaterials.materiales.map((material) => ({
              ...material,
              id: entity.id + material.SKU
            }))
          ]
        }
      }), {});
    },
    addFromUnity(unitMaterial) {
      this.selectEntities = Object.values(this.selectEntities).reduce((acumulador, entity) => ({
        ...acumulador,
        [entity.id]: {
          ...entity,
          materials: [
            ...entity.materials,
            {
              ...unitMaterial[0].materiales,
              id: entity.id + unitMaterial[0].materiales.SKU
            }
          ]
        }
      }), {});
    },
    openModalFromUnit() {
      this.showModals('PopUpAddFromUnity');
    },
    openModalFromCatalog() {
      this.showModals('PopUpAddFromCatalog');
    },
    getChildrenEntities(item) {
      this.loadOptionChildrenList(item);
    },
    totalRequest(row, entity) {
      // eslint-disable-next-line max-len
      this.selectEntities[entity.id].materials[row.index].totalSolicitar = (row.item.precio * row.item.cantidadSolicitar);
    },
    async saveChanges() {
      const isValid = await this.validateForm('data-user');
      if (!isValid) {
        return;
      }
      this.confirmRequestAction();
    },
    async finishRequest() {
      const finalUserData = {
        ...this.userData,
        name: this.currentUser.nombre
      };
      const requestData = {
        ...finalUserData,
        precioSolicitudTotal: this.requestFinalPrice,
        statusCode: 1,
        statusDescription: 'Creada',
        detail: [
          ...Object.values(this.selectEntities).filter((item) => item.selected)
        ],
      };
      await this.addMaterialRequest(requestData);
      this.goToMaterialRequests();
    },
    goToMaterialRequests() {
      this.$router.push({ name: 'material-requests', params: { view: 'general' } });
    },
    confirmRequestAction() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: '¿Estás seguro continuar con la creación de la Solicitud de Materiales?',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.finishRequest(),
        cancel: () => { }
      });
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async resetMaterials() {
      this.childrenEntities = this.selectEntities.map((entity) => ({
        entity: {
          ...entity,
          materials: []
        }
      }));
      this.selectEntities = this.selectEntities.map((entity) => ({
        ...entity,
        materials: []
      }));
      this.activeAccordionId = '';
      this.isAccordionOpen = false;
    },
  },
  watch: {
    selectedEntities(value) {
      this.selectEntities = Object.values(this.selectEntities).reduce((acumulador, entity) => ({
        ...acumulador,
        [entity.id]: {
          ...entity,
          selected: value?.some((item) => item.id === entity.id)
        }
      }), {});
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#user-list > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#user-list',
        scale: 0.6
      });
    },
  },
};
</script>

<style>
.children-entities {
  padding: 2px 2px 2px 15px;
  height: 100px;
  overflow-y: scroll;
  border: 1px solid #DFDBE5;
  border-radius: 5px;
}

.dropdown-option-menu {
  right: 1px;
  position: absolute;
}

.dropdown-option {
  width: 150px;
}
</style>
